import { render, staticRenderFns } from "./BhpFormEdit.vue?vue&type=template&id=2c5f3e53&"
import script from "./BhpFormEdit.vue?vue&type=script&lang=js&"
export * from "./BhpFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./BhpFormEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports